import { notification } from 'antd'

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  fetchWithPagination,
  toggle
} from '../../api/admin/language'

import { key as cacheKey } from '../cache/language'

const key = 'admin.language'

export const useList = (queryParams) => {
  return useQuery({
    queryKey: [key, queryParams],
    queryFn: () => fetchWithPagination(queryParams)
  })
}

export const useToggle = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: toggle,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])
      queryClient.invalidateQueries([cacheKey])

      notification.success({
        message: 'Updated',
        description: 'The language was updated'
      })
    },
    onError: (error, variables, context) => {
      // window.alert('error')
    },
    onSettled: (data, error, variables, context) => {
      // Error or success... doesn't matter!
      // after success
    }
  })
}